import { BasicAPI } from '../../core-apis/src/apis/config/api/basicApi'

const WIGGOT_API = process.env.WIGGOT_API ?? ''

class WiggotAPI extends BasicAPI {
  constructor() {
    super({
      domain: WIGGOT_API
    })
  }
}

export const wiggotAPI = new WiggotAPI()
